import { quarterlyRoyaltySteps } from '../constants';

/**
 * Get a royalty value based on the quarterly run rate. The royalty value should be the lowest valid
 * option that is greater than or equal to the quarterly run rate.
 * @param quarterlyRunRate
 * @returns
 */
export const getRoyaltyCapacityFromQRR = (
    quarterlyRunRate: Maybe<number>,
): number => {
    if (quarterlyRunRate === null) {
        return quarterlyRoyaltySteps[0];
    }

    const indexOfMinRoyaltyValue = quarterlyRoyaltySteps.findIndex(
        (stepValue: number): boolean => stepValue >= quarterlyRunRate,
    );

    if (indexOfMinRoyaltyValue > -1) {
        return quarterlyRoyaltySteps[indexOfMinRoyaltyValue];
    }

    return quarterlyRoyaltySteps[0];
};
